import _ from 'lodash'
import api from '@/utils/api'
import STATUS from '@/utils/status'
import Vue from 'vue'

import eventsBus from '@/components/shared/EventsBus'

let defaultChatData = {
  conversation: null,
  users: [],
  status: STATUS.IDLE
}

let state = {
  userStatus: 'connected',
  userStatusConsts: {
    CONNECTED: 'connected',
    DISCONNECTED: 'disconnected'
  },
  soundNotification: true,
  desktopNotification: true,
  onlineContacts: [],
  listOfUsers: [],
  chatData: {},
  quickConversationUsers: null,
  generalStatus: STATUS.LOADING
}

let originalState = _.cloneDeep(state)

let actions = {
  setOnlineContacts (ctx, data) {
    let contacts = data.onlineContacts
    ctx.state.onlineContacts = contacts
    let users = _.flatMap(data.conversations, (c) => c.participants)
    users = _.uniqBy([...contacts, ...users], 'id')
    users = users.filter((u) => u.id !== ctx.rootGetters['user/user'].id)
    ctx.state.listOfUsers = users
    ctx.state.generalStatus = STATUS.LOADED
  },
  setQuickConversationUsers ({state}, users) {
    state.quickConversationUsers = users
  },
  deselectQuickConversation ({state}) {
    state.quickConversationUsers = null
  },
  getChatFor (ctx, contacts) {
    let usersIds = _.join(_.sortBy(_.map(contacts, (c) => c.id)), ',')
    return new Promise((resolve, reject) => {
      if (ctx.state.chatData[usersIds]) {
        return resolve(ctx.state.chatData[usersIds])
      }

      let chatInfo = _.cloneDeep(defaultChatData)
      Vue.set(ctx.state.chatData, usersIds, chatInfo)
      chatInfo.status = STATUS.LOADING
      api.get('chatConversation', {params: { users: _.map(contacts, (c) => c.id) }})
      .then((response) => {
        let conversation = response.data.conversation
        if (conversation === null) {
          ctx.dispatch('conversations/newConversation', {forChat: _.map(contacts, (c) => c.id)}, {root: true}).then((conv) => {
            ctx.state.chatData[usersIds].conversation = conv
            chatInfo.users = contacts
            chatInfo.status = STATUS.LOADED
            resolve(chatInfo)
          })
          return
        }
        chatInfo.users = conversation.participants
        ctx.state.chatData[usersIds].conversation = conversation
        if (conversation.unreadMessages > 0) {
          chatInfo.status = STATUS.NEW
        }
        api.get('messages', {params: {convId: response.data.conversation.id}}).then((response) => {
          Vue.set(chatInfo.conversation, 'messages', response.data.messages)
          if (chatInfo.status !== STATUS.NEW) {
            chatInfo.status = STATUS.LOADED
            resolve(chatInfo)
          }
        })
      })
    })
  },
  getNewMessages (ctx, conversation) {
    let chatInfo = ctx.state.chatData[conversation.chatUsersIds]
    if (!chatInfo) {
      return ctx.dispatch('getChatFor', conversation.chatUsersIds.split(',').map(id => ({id: id, kind: 'user'}))).then((chatInfo) => {
        chatInfo.status = STATUS.NEW
        eventsBus.$emit(eventsBus.NEW_MESSAGE)
      })
    }
    let conv = chatInfo.conversation
    if (chatInfo.conversation.id < 0) {
      chatInfo.conversation = conversation
      conv = conversation
      conv.nbMessages = 0
      Vue.set(chatInfo.conversation, 'messages', [])
    }
    return api.get('messages/' + conv.nbMessages, {params: {convId: conv.id}}).then((response) => {
      _.each(response.data.messages, (m) => {
        let newStatus = false
        let index = _.findIndex(conv.messages, {id: m.id})
        if (index === -1) {
          conv.messages.push(m)
          conv.nbMessages++
          if (m.sender.id !== ctx.rootGetters['user/user'].id) { // possible if several open windows for one same user
            newStatus = true
          }
        } else {
          conv.messages[index].time = m.time
        }
        if (newStatus) {
          chatInfo.status = STATUS.NEW
          eventsBus.$emit(eventsBus.NEW_MESSAGE)
        }
      })
    })
  },
  setAsRead (ctx, chatInfo) {
    if (chatInfo.status === STATUS.NEW) {
      chatInfo.status = STATUS.LOADED
      api.put('conversation/' + chatInfo.conversation.id, {mark: 'read'})
    }
  },
  clean ({state}) {
    for (let attr in originalState) {
      state[attr] = originalState[attr]
    }
  },
  setConfiguration ({state}, conf) {
    state.userStatus = conf.status
    state.soundNotification = conf.soundNotification
    state.desktopNotification = conf.desktopNotification
  },
  saveConfiguration ({state, dispatch}, conf) {
    return api.put('/chatConfiguration', conf).then((response) => {
      dispatch('setConfiguration', response.data.conf)
    })
  }
}

let getters = {
  onlineContacts (state) {
    if (state.userStatus !== 'disconnected') {
      return state.onlineContacts
    }
    return []
  },
  userIsOnline (state) {
    return (user) => {
      if (state.userStatus !== 'disconnected') {
        return _.find(state.onlineContacts, (u) => u.id === user.id) !== undefined
      }
      return false
    }
  },
  listOfUsers (state) {
    if (state.userStatus !== 'disconnected') {
      return state.listOfUsers
    }
    return []
  },
  generalStatus (state) {
    return state.generalStatus
  },
  quickConversationUsers (state) {
    return state.quickConversationUsers
  },
  chatDataFor (state) {
    return (users) => {
      let usersIds = _.join(_.sortBy(_.map(users, (c) => c.id)), ',')
      return state.chatData[usersIds]
    }
  },
  userStatus (state) {
    return state.userStatus
  },
  soundNotification (state) {
    return state.soundNotification
  },
  desktopNotification (state) {
    return state.desktopNotification
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/chat.js